<template>
    <span :class="textClass">{{ row.Borc  || '-' }}</span>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        textClass(){
            return this.row.Borc ? 'text-primary font-weight-bolder' : ''
        }
    }
}
</script>